import React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { Homepage } from './pages/Homepage/Homepage';
import { UIKit } from './pages/UIKit/UIKit';
import './styles/reset.css';
import './styles/common.css';
import './styles/main.scss';
import Products from './pages/Products';
import Resources from './pages/Resources';
import MainLayout from './Layout/main';
import AboutProducts from 'pages/AboutProduct';
import RelatedProduct from 'pages/RelatedProduct';
import CropNutritionPrograms from 'pages/CropNutritionPrograms';
import TrialResults from 'pages/TrialResults';
import DetailedOfCropNutrition from 'pages/DetailedOfCropNutrition';
import DetailedTrialResults from 'pages/DetailedTrialResults';
import InformationMaterials from 'pages/InformationMaterials';
import AboutUs from 'pages/AboutUs';
import News from 'pages/News';
import { ROUTES } from './constants/routes';
import Research from 'pages/Research';
import Article from 'pages/Article';
import DetailedJob from 'pages/DetailedJob';
import Career from 'pages/Career';
import TermsAndConditions from 'pages/TermsAndConditions';
import LegalInfo from 'pages/LegalInfo';
import Contacts from 'pages/Contacts';
import Page404 from 'pages/Page404';

const router = createBrowserRouter([
    { path: '/ui-kit', element: <UIKit /> },
    {
        path: ROUTES.base,
        element: <MainLayout />,
        children: [
            { index: true, element: <Homepage /> },
            { path: ROUTES.products, element: <Products /> },
            { path: ROUTES.aboutProduct, element: <AboutProducts /> },
            { path: ROUTES.relatedProduct, element: <RelatedProduct /> },
            { path: ROUTES.resources, element: <Resources /> },
            { path: ROUTES.cropNutritionPrograms, element: <CropNutritionPrograms /> },
            { path: ROUTES.trialResults, element: <TrialResults /> },
            { path: ROUTES.detailCropNutritionPrograms, element: <DetailedOfCropNutrition /> },
            { path: ROUTES.detailTrialResults, element: <DetailedTrialResults /> },
            { path: ROUTES.informationMaterials, element: <InformationMaterials /> },
            { path: ROUTES.aboutUs, element: <AboutUs /> },
            { path: ROUTES.news, element: <News /> },
            { path: ROUTES.research, element: <Research /> },
            { path: ROUTES.article, element: <Article /> },
            { path: ROUTES.career, element: <Career /> },
            { path: ROUTES.detailJob, element: <DetailedJob /> },
            { path: ROUTES.termsAndConditions, element: <TermsAndConditions /> },
            { path: ROUTES.legalInfo, element: <LegalInfo /> },
            { path: ROUTES.contacts, element: <Contacts /> },
            { path: '*', element: <Page404 /> },
        ],
    },
]);

ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
        <RouterProvider router={router} />
    </React.StrictMode>,
);
